export class ApiModel {

  constructor(data: any) {
    Object.assign(this, data);
  }

}



// WEBPACK FOOTER //
// ./src/app/models/api-model.ts